<template>
    <div>
        <data-table v-if="ready" class="table table-striped" ref="table"
            :columns="columns"
            :data="issues"
            :loading="loading"
            :datatableOptions="datatableOptions"

            @clicked="openSummary($event)"
        />
        <modal ref="summary" @hidden="summary = null" :options="{ minHeight: 200 }">
            <template v-slot:modal-title>
                <h3><i class="fas fa-info-circle"></i> {{summary.title}}</h3>
            </template>
            <template v-slot:modal-body>
                <span v-html="summary.body">
                </span>
            </template>
        </modal>
    </div>
</template>

<script>

//Util
import {defaultContentType} from '../../../Components/Util/DataTable/DataTable.vue';
import _ from 'lodash';
import $ from 'jquery';
import api from '../api';
import moment from 'moment';

//Mixins
import resourceMixin from '../../../Util/Mixins/resources';
import sprintMixin from '../Mixins/sprint';
import regexMixin from '../Mixins/regex'

//Components
//import Edit from './Edit.vue';
//import Comments from './Comments.vue';
import Modal  from '@core/Components/Util/Modal';

const EXPAND_TOGGLE_COLUMN_CLASS = 'expand-toggle';

export default {
    name: 'sprint-planning-sprint',
    components: {
        Modal
    },
    mixins: [ resourceMixin, sprintMixin, regexMixin ],
    methods: {
        openSummary(event) {
            if(
                !event || 
                !event.issueId ||
                (
                    event._originalEvent && 
                    event._originalEvent.target.classList.contains(EXPAND_TOGGLE_COLUMN_CLASS)
                )
            ){
                return;   
            }

            const issue = this.issues.find(issue => issue.issueId === event.issueId);

            this.summary = {
                title: `${this.resource('SprintPlanning_Issue_Summary_DisplayName')}: ${issue.issueId}`,
                body: issue.summary ? this.parseString(issue.summary) : this.resource('SprintPlanning_Issue_Summary_Default')
            };

            this.$refs.summary.show();
        }
    },
    computed: {
        columns() {
            const dateRenderer = data => {
                return `
                    <span hidden>${moment(new Date(data)).format('YYYY-MM-DD')}</span>
                    <span>${moment(new Date(data)).format('DD-MM YYYY')}</span>
                `;
            }
            
            const vm = this;
            const columns = [];
            
            columns.push(
                //Hack, column for expand/collapse button
                //clicking on a row will always trigger our popup, we don't want this when expanding/collapsing a row
                //the expand/collapse button is rendered via a :before psuedo element however, making it impossible to actually detect a click
                //therefore we're moving the button to it's own column -> ignoring any clicks on said column  
                { render: () => '&nbsp;', className: EXPAND_TOGGLE_COLUMN_CLASS, orderable: false },
                { title: this.resource('SprintPlanning_Issue_Created_DisplayName'), data: 'created', render: dateRenderer},
                { title: this.resource('SprintPlanning_Issue_Updated_DisplayName'), data: 'updated', render: dateRenderer},
                { title: this.resource('SprintPlanning_Issue_Key_DisplayName'), data: 'issueId'},
                { title: this.resource('SprintPlanning_Issue_Title_DisplayName'), data: 'title', responsivePriority: -1 },
                { title: this.resource('SprintPlanning_Issue_Priority_DisplayName'), data: 'priority', render: (data) => {
                    return `<span hidden>${data.id}</span>  <img src="${data.iconUrl}" width="25px" />`;
                }},
                { title: this.resource('SprintPlanning_Issue_Status_DisplayName'), data: 'status', render: (data) => {
                    return `<span hidden>${data.statusCategory.id}</span> <span>${data.name}</span>`;
                }},
                { title: this.resource('SprintPlanning_Issue_Sprint_DisplayName'), data: 'sprint' },
                { title: this.resource('SprintPlanning_Issue_RequestedBy_DisplayName'), data: 'requestedBy.value', defaultContent: "-" },
                { title: this.resource('SprintPlanning_Issue_Size_DisplayName'), data: 'size.value', defaultContent: '-' },
                { title: this.resource('SprintPlanning_Issue_WaitingFor_DisplayName'), data: 'waitingFor.value', defaultContent: '-' },
            );
            
            columns.push(
                { data: 'assignee', visible: false },
                { data: 'priority', visible: false },
                { data: 'status', visible: false }
            );
            
            return columns;
        },
        ready() {
            return this.mixinReady;
        }
    },
    data: () => ({
        createdReady: false,
        datatableOptions: { 
            lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]], 
            pageLength: -1,
            sDom: '<"top"lip>rt<"bottom"lp> <"clear">',
            order: [ 1, 'asc' ]
        },
        issueToEdit: null,
        commentsIssue: null,
        canReadComments: false,
        canWriteComments: false,
        canWriteTimeTracking: false,
        summary: null
    })
};
</script>

<style lang="scss" scoped>
    ::v-deep td {
        cursor: pointer;
    }
</style>
